export enum UPLOAD_STATUS {
  READING_FILE = 0,
  COMPLETED = 1
};
